import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

export const EstimatedPriceLabel = ({ className }: { className?: string }) => {
  const { formatText } = useLocalization();

  return (
    <div className={`uitk-type-200 all-b-padding-one uitk-type-center ${className}`}>
      {formatText("hotels.estimatedPriceLabel")}
    </div>
  );
};
